<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ `Current Tag: ${tagObject.name}` }}</p>
    </header>
    <section class="modal-card-body">
      <b-select v-model="selectedTag" placeholder="Select a tag">
        <option
          v-for="tag in availableTags"
          :value="tag.value"
          :key="tag.value"
          >{{ tag.name }}</option
        >
      </b-select>
    </section>
    <footer class="modal-card-foot">
      <div class="left">
        <button class="button" type="button" @click="$parent.close()">
          Close
        </button>
        <b-button
          type="is-info"
          :disabled="!selectedTag"
          :loading="loading"
          @click="applyTag([selectedTag])"
          >Apply</b-button
        >
      </div>
      <div class="right">
        <b-button type="is-warning" @click="applyTag([])">
          Untag
        </b-button>
      </div>
    </footer>
  </div>
</template>

<script>
import { ref } from "@vue/composition-api";
import ui from "@/store/modules/ui";
import useSnackbar from "@/composables/useSnackbar";
import useTags from "@/composables/useTags";

export default {
  setup() {
    // Composables
    // ---------------------------------------------------------------
    //
    const { availableTags, tagObject, syncTags } = useTags();
    const { open: openSnack } = useSnackbar();
    //
    // Ui States
    // ---------------------------------------------------------------
    //
    const selectedTag = ref(null);
    //
    // Apply Tag
    // ---------------------------------------------------------------
    //
    const loading = ref(false);
    const applyTag = async newTag => {
      // Start Loading
      loading.value = true;
      try {
        // Sync tags with server
        await syncTags(newTag);
        // Unsaved changes are sent to the server at the same time.
        ui.setHasUnsavedChange(false);
      } catch (error) {
        // Sync Failed
        console.error(error);
        // Alert user.
        openSnack("Failed to access the server.");
      } finally {
        // End loading
        loading.value = false;
      }
    };
    return {
      tagObject,
      availableTags,
      selectedTag,
      loading,
      applyTag
    };
  }
};
</script>

<style lang="scss" scoped>
footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.left {
  display: flex;
  flex-direction: row;
}
.right {
  display: flex;
  flex-direction: row-reverse;
}
</style>
